const Checkins = () => import('./Checkins.vue')
const Checkin = () => import('./Checkin.vue')

export default [
    {
        path: 'checkin',
        redirect: 'checkin',
        name: 'checkin',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        meta: {
            label: 'Check-ins',
            title: 'Check-ins',
            breadcrumb: (context) => ({
                text: 'Check-ins',
                to: { name: 'checkin.list', params: context.route.params }
            })
        },
        children: [
            {
                path: '',
                name: 'checkin.list',
                meta: {
                    title: 'Check-ins',
                },
                component: Checkins
            },
            {
                path: ':id',
                name: 'checkin.detail',
                meta: {
                    title: 'Check-in detail',
                    breadcrumb: (context) => {
                        const checkin = context.store.getters['checkin/checkin']
                        return {
                            text: checkin?.picacode || `Check-in #${context.route.params.id}`
                        }
                    }
                },
                component: Checkin
            }
        ]
    }
]